import { Link, useLocation } from 'react-router-dom';
import { Home, LayoutGrid, Film, Upload, User, Users } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { useUnreadMessages } from '../lib/unreadMessages';
import { useT } from '../i18n';
import { ComicBubble } from './ComicBubble';

export function MobileBottomNav() {
    const { user } = useAuth();
    const { pathname } = useLocation();
    const t = useT();
    const { total: unread } = useUnreadMessages();

    const items = [
        { to: '/', label: t('nav.home'), icon: Home, testid: 'bottom-nav-home', match: (p) => p === '/' },
        { to: '/categories', label: t('nav.categories'), icon: LayoutGrid, testid: 'bottom-nav-categories', match: (p) => p.startsWith('/categories') },
        { to: '/shorts', label: t('nav.shorts'), icon: Film, testid: 'bottom-nav-shorts', match: (p) => p.startsWith('/shorts') },
        { to: user ? '/amics' : '/entrar', label: t('nav.friends'), icon: Users, testid: 'bottom-nav-friends', match: (p) => p.startsWith('/amics') },
        { to: user ? '/pujar' : '/entrar', label: t('nav.upload'), icon: Upload, testid: 'bottom-nav-upload', match: (p) => p.startsWith('/pujar') },
        { to: user ? '/perfil' : '/entrar', label: user ? t('nav.profile') : t('nav.login'), icon: User, testid: 'bottom-nav-profile', match: (p) => p.startsWith('/perfil') || p.startsWith('/entrar') },
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-[color:var(--alb-hairline)] bg-[rgba(15,19,27,0.88)] backdrop-blur px-2 pt-2 pb-[calc(env(safe-area-inset-bottom)+8px)]" data-testid="mobile-bottom-nav">
            <ul className="grid grid-cols-6 gap-1">
                {items.map(({ to, label, icon: Icon, testid, match }) => {
                    const active = match(pathname);
                    return (
                        <li key={to + label}>
                            <Link to={to} data-testid={testid} className={`relative flex flex-col items-center gap-1 py-2 rounded-xl text-[11px] min-h-[44px] ${active ? 'text-[color:var(--alb-sun)] bg-[rgba(244,200,74,0.08)]' : 'text-[color:var(--alb-text-muted)]'}`}>
                                <Icon className={`h-5 w-5 ${active ? 'text-[color:var(--alb-sun)]' : ''}`} />
                                <span className="truncate max-w-full">{label}</span>
                                {testid === 'bottom-nav-friends' && (
                                    <span className="absolute -top-1 right-0 pointer-events-none" data-testid="bottom-nav-friends-unread">
                                        <ComicBubble count={unread} size="sm" tail="down" />
                                    </span>
                                )}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
